import Ticket from './index';
import LoginUser from './LoginUser';
import NotLoggedInUser from './NotLoggedInUser';
import OperateUser from './inside/operateUser';
import DevelopUser from './inside/developUser';

export default {
  path: '/home/ticket',
  component: Ticket,
  redirect: '/home/ticket/loginUser',
  children: [
    { path: '/home/ticket/loginUser', component: LoginUser },
    { path: '/home/ticket/notLoggedInUser', component: NotLoggedInUser },
    { path: '/home/ticket/operateUser', component: OperateUser },
    { path: '/home/ticket/developUser', component: DevelopUser },
  ]
};
